import { GET_BLOGS } from "../ActionTypes"

const initialState = {
	blogs: [],
	loading: false
}
export default (state = initialState, { type, payload }) => {
	switch (type) {
		case GET_BLOGS + "_FULFILLED":
			return {
				...state,
				blogs: payload.data.getAllBlog.data,
				loading: false
			}
		case GET_BLOGS + "_PENDING":
			return { ...state, loading: true }
		case GET_BLOGS + "_REJECTED":
			return { ...state, loading: false }
		default:
			return state
	}
}
